import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useConsent } from "../context/ConsentContextBanner"; // oder wie dein Export heißt

export default function AnalyticsTracker() {
  const location = useLocation();
  const { hasConsent } = useConsent();

  useEffect(() => {
    if (hasConsent) {
      const page = location.hash || window.location.hash || "/";
      ReactGA.send({ hitType: "pageview", page });
    }
  }, [location, hasConsent]);

  return null;
}
